var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":_vm.elemWidth,"height":"40","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":_vm.generatePath(_vm.elemWidth),"fill":"none","stroke":"black"}})])}
var staticRenderFns = []

export { render, staticRenderFns }